import React, { useEffect, useState } from "react";
import { Routes, Route, Outlet } from "react-router-dom";
import { layoutTypes } from "./constants/layout";

import Authmiddleware from "./routes/authmiddleware";
import VerticalLayout from "./components/VerticalLayout";

import HorizontalLayout from "./components/HorizontalLayout";
import "./assets/scss/theme.scss";
import fakeBackend from "./helpers/AuthType/fakeBackend";
import Signin from "pages/Signin/signin";
import "./assets/css/custom.css";
import { UserTypes } from "enum/UserTypes";

//pages
import CurrentOrders from "pages/Orders/CurrentOrders";
import FutureOrders from "pages/Orders/FutureOrders";
import DeliveredOrders from "pages/Orders/DeliveredOrders";
import CanceledOrders from "pages/Orders/CanceledOrders";
import AddressBook from "pages/AddressBook/AddressBook";
import Invoices from "pages/Invoices/Invoices";
import PaymentLogs from "pages/PaymentLogs/PaymentLogs";
import Pages404 from "components/Common/NotFound";
import Signup from "pages/Signup/signup";
import PaymentSuccess from "components/Common/PaymentSuccess";
import PaymentFailed from "components/Common/PaymentFailed";
import PlaceOrdersBusiness from "pages/PlaceOrders/PlaceOrdersBusiness";
import EmailVerification from "pages/EmailVerification/emailVerification";
import PrivateRoute from "components/Common/PrivateRouteComponent/PrivateRoute";
import FailedOrders from "pages/Orders/FailedOrders";
import ForgetPassword from "pages/ForgetPassword/forgetPassword";
import PasswordReset from "pages/ForgetPassword/passwordReset";
import ResetVerification from "pages/ForgetPassword/resetVerification";
import Users from "admin/PlaceOrders/Users";
import { AuthService } from "services/AuthService";
import { AuthData, useAuth } from "context/AuthProvider";
import ManageCustomers from "admin/ManageCustomers/ManageCustomers";
import AdminLiveOrders from "admin/dispatch/adminLiveOrders/AdminLiveOrders";
import AdminUpcomingOrders from "admin/dispatch/adminUpcomingOrders/AdminUpcomingOrders";
import AdminDraftOrders from "admin/dispatch/adminDraftOrders/AdminDradtOrders";
import AdminCurrentOrders from "admin/dispatch/adminCurrentOrders/AdminCurrentOrders";
import AdminCanceledOrders from "admin/dispatch/adminCanceledOrders/AdminCanceledOrders";
import AdminDeliveredOrders from "admin/dispatch/adminDeliveredOrders/AdminDeliveredOrders";
import ManageDrivers from "admin/manageDrivers/ManageDrivers";
import ManageServices from "admin/manageOrders/manageService/ManageServices";
import AdminPickupOrders from "admin/dispatch/adminPickupOrders/AdminPickupOrders";
import AdminFaildPickupOrders from "admin/dispatch/adminFaildPickupOrders/AdminFaildPickupOrders";
import AdminFutureOrders from "admin/dispatch/adminFutureOrders/AdminFutureOrders";
import AdminReturnOrders from "admin/dispatch/adminReturnOrders/AdminReturnOrders";
import AdminReattemptOrders from "admin/dispatch/adminReattemptOrders/AdminReattemptOrders";
import CustomerBilling from "admin/CustomerBilling/CustomerBilling";
import Profile from "pages/Profile/Profile";
import ChangePassword from "pages/Profile/ChangePassword";
import AdminBilledOrders from "admin/dispatch/adminBilledOrders/AdminBilledOrders";
import AdminDeliveredToday from "admin/dispatch/adminDeliveredToday/AdminDeliveredToday";
import { ImageData, useImage } from "context/ProfileImageProvider";
import DriverBilling from "admin/DriverBilling/DriverBilling";
import AdminFinance from "admin/Finance/Finance";
import Quote from "admin/Quote/Quote";
import DraftOrders from "pages/DraftOrders/DraftOrders";
import ReturnOrders from "pages/Orders/ReturnOrders";
import ReattemptOrders from "pages/Orders/ReattemptOrders";
import BilledOrders from "pages/Orders/BilledOrders";
import ViewAllNotification from "pages/Notification/Notification";
import ViewCustomerBilling from "admin/CustomerBilling/View Billing/ViewCustomerBilling";
import AddDispatchUser from "pages/Profile/AddDispatchUser";
import CustomerReports from "pages/Profile/Reports/CustomerReports";
import OrderReports from "pages/Profile/Reports/OrderReports";
import PaymentSuccessInvoice from "components/Common/PaymentSuccessInvoice";
import TermsOfService from "pages/TermsOfService/Index";
import DriverView from "admin/DriverBilling/View Billing/DriverView";
import LatestReport from "admin/DriverBilling/LatestReport";
import PendingUsers from "admin/pendingUser/pendingUser";
import Landing from "pages/Landing";
import DriverOldBillingView from "admin/DriverBilling/DriverOldBillingView";
import OldReports from "admin/DriverBilling/OldReports";
import PendingDrivers from "admin/manageDrivers/PendigDrivers";
import AvailableDrivers from "admin/manageDrivers/driverAbailability";
import AvailableDriverSlot from "admin/manageDrivers/driverAbailabilityslot";
import DriverAvailableOrders from "driver/orders/driverAvailableOrders/DriverAvailabaleOrders";
import Broadcast from "admin/Broadcast/Broadcast";
import Tracking from "pages/Tracking/tracking";
import { NotificationService } from "services/NotificationService";
import { toast } from "react-toastify";
import zuluLogo from '../src/assets/images/broadcast.png'; // Adjust path as needed
import BulkRequest from "pages/BulkRequest/BulkRequest";
import BulkRequestManager from "admin/BulkRequestManager/BulkRequestManager";
import AdminBulkRequest from "admin/BulkRequestManager/AdminBulkRequest";
import AdminShift from "admin/Shift/AdminShift";
import { connectSocket } from "services/socket";

import Cards from "pages/Cards/Cards";
import CardPayment from "pages/Cards/CardPayment";
import AdminBilledOrdersHistory from "admin/dispatch/adminBilledOrderHistory/AdminBilledOrdersHistory";
import DriverTracking from "admin/DriverTracking/DriverTracking";
import ShopifyOnboarding from "./pages/Integrations/ShopifyOnboarding";
import ShopifyDashboard from "./pages/Integrations/ShopifyDashboard";
import WooCommerceOnboarding from "./pages/Integrations/WooCommerceOnboarding";
import WooCommerceDashboard from "./pages/Integrations/WooCommerceDashboard";
import CustomDashboard from "./pages/Integrations/CustomDashboard";
import CustomOnboarding from "./pages/Integrations/CustomOnboarding";
import CustomApiKeyReveal from "./pages/Integrations/CustomApiKeyReveal";
import MerchantDashboard from "./pages/Integrations/MerchantDashboard";
import MerchantPortalLogin from "./pages/MerchantPortal/MerchantPortalLogin";
import Stores from "admin/Stores/Stores";
import EditStore from "admin/Stores/EditStore";
import StoreDetails from "admin/Stores/StoreDetails";
import StoreServiceWizard from "admin/Stores/StoreServiceWizard";
import CustomerStores from "pages/Stores/CustomerStores";

// Activating fake backend
fakeBackend();

const getLayout = (layoutType: string) => {
  let Layout = VerticalLayout;
  switch (layoutType) {
    case layoutTypes.VERTICAL:
      Layout = VerticalLayout;
      break;
    case layoutTypes.HORIZONTAL:
      Layout = HorizontalLayout;
      break;
    default:
      break;
  }
  return Layout;
};

const App: React.FC = () => {
  const Layout = getLayout(layoutTypes.VERTICAL);
  const [user] = useAuth() as AuthData;
  const [image, setImage] = useImage() as ImageData;
  const remember = localStorage.getItem("remember");
  const [broadcasts, setBroadcasts] = useState<{ id: string; message: string }[]>([]);

  useEffect(() => {
    if (!user?.photoId?._id) return;
    AuthService.getProfileImage(user.photoId._id)
      .then(rawBinary => {
        const blob = new Blob([rawBinary as any], { type: 'image/jpeg' }); // Specify the correct MIME type
        const reader = new FileReader();
        reader.onload = () => {
          if (typeof reader.result === 'string') {
            setImage({
              dataURL: reader.result
            });
          }
        };

        reader.readAsDataURL(blob);
      })
      .catch(err => {
        console.error("Error loading image:", err);
      });
  }, [user]);

  useEffect(() => {
    if (
      user &&
      (user.role === UserTypes.PERSONAL_CUSTOMER || user.role === UserTypes.BUSINESS_CUSTOMER)
    ) {
      const socket = connectSocket(user._id);
      const storageKey = `dismissedBroadcasts_${user._id}`;
      let dismissedBroadcasts: string[] = JSON.parse(localStorage.getItem(storageKey) || "[]");

      const addBroadcast = (id: string, message: string) => {
        if (!dismissedBroadcasts.includes(id)) {
          setBroadcasts((prev) => [...prev, { id, message }]);
        }
      };

      const fetchAndShowBroadcasts = async () => {
        try {
          if (user._id) {
            const response = await NotificationService.getBroadcastMessagesOfCustomer(user._id);
            if (response.success && response.data) {
              response.data.forEach((broadcast: { message: string }, index: number) => {
                const id = `broadcast-${index}-${broadcast.message}`;
                addBroadcast(id, broadcast.message);
              });
            }
          }
        } catch (error) {
          console.error("Failed to fetch broadcasts:", error);
        }
      };

      const handleSocketBroadcast = (data: { message: string }) => {
        const id = `socket-${Date.now()}-${data.message}`;
        addBroadcast(id, data.message);
      };

      fetchAndShowBroadcasts();

      if (socket?.on) {
        socket.on("broadcasting", handleSocketBroadcast);
      }

      return () => {
        socket?.off("broadcasting", handleSocketBroadcast);
      };
    }
  }, [user]);

  const dismissBroadcast = (id: string) => {
    const storageKey = user ? `dismissedBroadcasts_${user._id}` : "";
    const dismissed = JSON.parse(localStorage.getItem(storageKey) || "[]");
    const updated = [...dismissed, id];
    localStorage.setItem(storageKey, JSON.stringify(updated));
    setBroadcasts((prev) => prev.filter((b) => b.id !== id));
  };


  return (
    <React.Fragment>
      {broadcasts.map((b) => (
        <div
          key={b.id}
          style={{
            backgroundColor: "#f59e0b",
            // backgroundColor: "#f76c36",
            color: "#fff",
            padding: "10px 20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            zIndex: 9999,
            fontWeight: 500
          }}
        >
          <span
            style={{
              position: "absolute",
              left: "12px",
              display: "flex",
              alignItems: "center"
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="white"
              viewBox="0 0 24 24"
            >
              <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
            </svg>
          </span>

          <span>Message from Zulu: "{b.message}"</span>


          <button
            onClick={() => dismissBroadcast(b.id)}
            style={{
              position: "absolute",
              right: "12px",
              background: "none",
              border: "none",
              fontSize: "25px",
              cursor: "pointer",
              color: "#fff"
            }}
          >
            ×
          </button>
        </div>
      ))}
      <Routes>
        <Route path="/signin" element={
          (user?.role == UserTypes.PERSONAL_CUSTOMER || user?.role == UserTypes.BUSINESS_CUSTOMER) && remember == "Yes" ? (
            <Layout>{<PlaceOrdersBusiness />}</Layout>
          ) : <Signin />
        }> </Route>
        <Route path="/signup" element={<Signup />}></Route>
        <Route path="/merchant" element={<MerchantPortalLogin />}></Route>
        <Route path="/merchant/login" element={<MerchantPortalLogin />}></Route>
        <Route path="/integrations/shopify/onboarding" element={<ShopifyOnboarding />}></Route>
        <Route path="/integrations/shopify/dashboard" element={<ShopifyDashboard />}></Route>
        <Route path="/integrations/woocommerce/onboarding" element={<WooCommerceOnboarding />}></Route>
        <Route path="/integrations/woocommerce/dashboard" element={<WooCommerceDashboard />}></Route>
        <Route path="/integrations/custom/onboarding" element={<CustomOnboarding />}></Route>
        <Route path="/integrations/custom/api-key" element={<CustomApiKeyReveal />}></Route>
        <Route path="/integrations/custom/dashboard" element={<CustomDashboard />}></Route>
        <Route path="/integrations/:platform/dashboard" element={<MerchantDashboard />}></Route>
        <Route path="/forget-password" element={<ForgetPassword />}></Route>
        <Route path="/password-reset" element={<PasswordReset />}></Route>
        <Route path="/reset-verification/:id" element={<ResetVerification />}></Route>
        <Route
          path="/email-verification"
          element={
            <PrivateRoute redirectTo="/signin">
              <EmailVerification />
            </PrivateRoute>
          }
        ></Route>

        <Route path="/quote" element={<Quote />}></Route>
        <Route path="/terms-of-service" element={<TermsOfService />}></Route>
        <Route path="/" element={<Landing />}></Route>

        <Route element={<Authmiddleware allowed={UserTypes.BUSINESS_CUSTOMER} />}>
          <Route path="/business_customer" element={<Outlet />}>
            <Route path="place-orders" element={<Layout>{<PlaceOrdersBusiness />}</Layout>} />
            <Route path="current-orders" element={<Layout>{<CurrentOrders />}</Layout>} />
            <Route path="future-orders" element={<Layout>{<FutureOrders />}</Layout>} />
            <Route path="delivered-orders" element={<Layout>{<DeliveredOrders />}</Layout>} />
            <Route path="billed-orders" element={<Layout>{<BilledOrders />}</Layout>} />
            <Route path="canceled-orders" element={<Layout>{<CanceledOrders />}</Layout>} />
            <Route path="failed-orders" element={<Layout>{<FailedOrders />}</Layout>} />
            <Route path="return-orders" element={<Layout>{<ReturnOrders />}</Layout>} />
            <Route path="reattempt-orders" element={<Layout>{<ReattemptOrders />}</Layout>} />
            <Route path="address-book" element={<Layout>{<AddressBook />}</Layout>} />
            <Route path="invoices" element={<Layout>{<Invoices />}</Layout>} />
            <Route path="payment-logs" element={<Layout>{<PaymentLogs />}</Layout>} />
            <Route path="Cards" element={<Layout>{<Cards />}</Layout>} />
            <Route path="profile-settings" element={<Layout>{<Profile />}</Layout>}></Route>
            <Route path="change-password" element={<Layout>{<ChangePassword />}</Layout>}></Route>
            <Route path="payment-success/:order_id" element={<PaymentSuccess />} />
            <Route path="payment-card" element={<CardPayment />}></Route>
            <Route path="payment-success/invoice/:invoice_id" element={<PaymentSuccessInvoice />} />
            <Route path="payment-error" element={<PaymentFailed />} />
            <Route path="notification" element={<Layout>{<ViewAllNotification />}</Layout>} />
            <Route path="bulk-request" element={<Layout>{<BulkRequest />}</Layout>} />
            <Route path="stores" element={<Layout>{<CustomerStores />}</Layout>} />
            {/* <Route path="tracking" element={<Layout>{<Tracking />}</Layout>} /> */}

          </Route>
        </Route>

        <Route element={<Authmiddleware allowed={UserTypes.PERSONAL_CUSTOMER} />}>
          <Route path="/personal_customer" element={<Outlet />}>
            <Route path="place-orders" element={<Layout>{<PlaceOrdersBusiness />}</Layout>} />
            <Route path="current-orders" element={<Layout>{<CurrentOrders />}</Layout>} />
            <Route path="future-orders" element={<Layout>{<FutureOrders />}</Layout>} />
            <Route path="delivered-orders" element={<Layout>{<DeliveredOrders />}</Layout>} />
            <Route path="billed-orders" element={<Layout>{<BilledOrders />}</Layout>} />
            <Route path="canceled-orders" element={<Layout>{<CanceledOrders />}</Layout>} />
            <Route path="failed-orders" element={<Layout>{<FailedOrders />}</Layout>} />
            <Route path="return-orders" element={<Layout>{<ReturnOrders />}</Layout>} />
            <Route path="reattempt-orders" element={<Layout>{<ReattemptOrders />}</Layout>} />
            <Route path="address-book" element={<Layout>{<AddressBook />}</Layout>} />
            <Route path="payment-logs" element={<Layout>{<PaymentLogs />}</Layout>} />
            <Route path="Cards" element={<Layout>{<Cards />}</Layout>} />
            <Route path="profile-settings" element={<Layout>{<Profile />}</Layout>}></Route>
            <Route path="change-password" element={<Layout>{<ChangePassword />}</Layout>}></Route>
            <Route path="payment-success/:order_id" element={<PaymentSuccess />} />
            <Route path="payment-error" element={<PaymentFailed />} />
            <Route path="draft-orders" element={<Layout>{<DraftOrders />}</Layout>} />
            <Route path="invoices" element={<Layout>{<Invoices />}</Layout>} />
            <Route path="payment-card/:promoCode?" element={<CardPayment />}></Route>
            <Route path="payment-success/invoice/:invoice_id" element={<PaymentSuccessInvoice />} />
            <Route path="notification" element={<Layout>{<ViewAllNotification />}</Layout>} />
            {/* <Route path="tracking" element={<Layout>{<Tracking />}</Layout>} /> */}
            <Route path="bulk-request" element={<Layout>{<BulkRequest />}</Layout>} />
            <Route path="stores" element={<Layout>{<CustomerStores />}</Layout>} />
          </Route>
        </Route>

        <Route element={<Authmiddleware allowed={UserTypes.SUPER_ADMIN} />}>
          <Route path="/super_admin" element={<Outlet />}>
            <Route path="place-orders" element={<Layout>{<Users />}</Layout>} />
            <Route path="manage-customers" element={<Layout>{<ManageCustomers />}</Layout>} />
            <Route path="stores" element={<Layout>{<Stores />}</Layout>} />
            <Route path="stores/:integrationId/services/:serviceId" element={<Layout>{<StoreServiceWizard />}</Layout>} />
            <Route path="stores/:integrationId/services/:serviceId/:step" element={<Layout>{<StoreServiceWizard />}</Layout>} />
            <Route path="stores/:integrationId/view" element={<Layout>{<StoreDetails />}</Layout>} />
            <Route path="stores/:integrationId" element={<Layout>{<EditStore />}</Layout>} />
            <Route path="stores/:integrationId/:tab" element={<Layout>{<EditStore />}</Layout>} />
            <Route path="manage-drivers" element={<Layout>{<ManageDrivers />}</Layout>} />
            <Route path="pending-drivers" element={<Layout>{<PendingDrivers />}</Layout>} />
            <Route path="available-drivers" element={<Layout>{<AvailableDrivers />}</Layout>} />
            <Route path="available-driver-slot" element={<Layout>{<AvailableDriverSlot />}</Layout>} />
            <Route path="upcoming-orders" element={<Layout>{<AdminUpcomingOrders />}</Layout>} />
            <Route path="live-orders" element={<Layout>{<AdminLiveOrders />}</Layout>} />
            <Route path="draft-orders" element={<Layout>{<AdminDraftOrders />}</Layout>} />
            <Route path="current-orders" element={<Layout>{<AdminCurrentOrders />}</Layout>} />
            <Route path="pick-up-orders" element={<Layout>{<AdminPickupOrders />}</Layout>} />
            <Route path="failed-pick-up-orders" element={<Layout>{<AdminFaildPickupOrders />}</Layout>} />
            <Route path="future-orders" element={<Layout>{<AdminFutureOrders />}</Layout>} />
            <Route path="delivered-orders" element={<Layout>{<AdminDeliveredOrders />}</Layout>} />
            <Route path="delivered-today" element={<Layout>{<AdminDeliveredToday />}</Layout>} />
            <Route path="billed-orders" element={<Layout>{<AdminBilledOrders />}</Layout>} />
            <Route path="billed-orders-history" element={<Layout>{<AdminBilledOrdersHistory />}</Layout>} />
            <Route path="return-orders" element={<Layout>{<AdminReturnOrders />}</Layout>} />
            <Route path="reattempt-orders" element={<Layout>{<AdminReattemptOrders />}</Layout>} />
            <Route path="canceled-orders" element={<Layout>{<AdminCanceledOrders />}</Layout>} />
            <Route path="manage-services" element={<Layout>{<ManageServices />}</Layout>} />
            <Route path="customer-billing" element={<Layout>{<CustomerBilling />}</Layout>} />
            <Route path="customer-billing-view" element={<Layout>{<ViewCustomerBilling />}</Layout>} />
            <Route path="profile-settings" element={<Layout>{<Profile />}</Layout>}></Route>
            <Route path="change-password" element={<Layout>{<ChangePassword />}</Layout>}></Route>
            <Route path="dispach-user" element={<Layout>{<AddDispatchUser />}</Layout>}></Route>
            <Route path="driver-billing" element={<Layout>{<DriverBilling />}</Layout>}></Route>
            <Route path="driver-billing-view" element={<Layout>{<DriverView />}</Layout>} />
            <Route path="latest-report" element={<Layout>{<LatestReport />}</Layout>} />
            <Route path="driver-old-billing-view" element={<Layout>{<DriverOldBillingView />}</Layout>} />
            <Route path="old-reports" element={<Layout>{<OldReports />}</Layout>} />
            <Route path="finance" element={<Layout>{<AdminFinance />}</Layout>}></Route>
            <Route path="quote" element={<Layout>{<Quote />}</Layout>}></Route>
            <Route path="notification" element={<Layout>{<ViewAllNotification />}</Layout>} />
            <Route path="payment-success/:order_id" element={<PaymentSuccess />} />
            <Route path="payment-error" element={<PaymentFailed />} />
            <Route path="pending-users" element={<Layout>{<PendingUsers />}</Layout>} />
            <Route path="reports/customer" element={<Layout>{<CustomerReports />}</Layout>} />
            <Route path="reports/orders" element={<Layout>{<OrderReports />}</Layout>} />
            <Route path="broadcast" element={<Layout>{<Broadcast />}</Layout>} />
            <Route path="driver-tracking" element={<Layout>{<DriverTracking />}</Layout>} />
            <Route path="bulk-request-manager" element={<Layout>{<BulkRequestManager />}</Layout>} />
            <Route path="bulk-request" element={<Layout>{<AdminBulkRequest />}</Layout>} />
            <Route path="shift" element={<Layout>{<AdminShift />}</Layout>} />

          </Route>
        </Route>

        <Route element={<Authmiddleware allowed={UserTypes.DISPATCH} />}>
          <Route path="/dispatch" element={<Outlet />}>
            <Route path="place-orders" element={<Layout>{<Users />}</Layout>} />
            <Route path="manage-customers" element={<Layout>{<ManageCustomers />}</Layout>} />
            <Route path="live-orders" element={<Layout>{<AdminLiveOrders />}</Layout>} />
            <Route path="draft-orders" element={<Layout>{<AdminDraftOrders />}</Layout>} />
            <Route path="current-orders" element={<Layout>{<AdminCurrentOrders />}</Layout>} />
            <Route path="pick-up-orders" element={<Layout>{<AdminPickupOrders />}</Layout>} />
            <Route path="failed-pick-up-orders" element={<Layout>{<AdminFaildPickupOrders />}</Layout>} />
            <Route path="future-orders" element={<Layout>{<AdminFutureOrders />}</Layout>} />
            <Route path="delivered-orders" element={<Layout>{<AdminDeliveredOrders />}</Layout>} />
            <Route path="delivered-today" element={<Layout>{<AdminDeliveredToday />}</Layout>} />
            <Route path="billed-orders" element={<Layout>{<AdminBilledOrders />}</Layout>} />
            <Route path="billed-orders-history" element={<Layout>{<AdminBilledOrdersHistory />}</Layout>} />
            <Route path="return-orders" element={<Layout>{<AdminReturnOrders />}</Layout>} />
            <Route path="reattempt-orders" element={<Layout>{<AdminReattemptOrders />}</Layout>} />
            <Route path="canceled-orders" element={<Layout>{<AdminCanceledOrders />}</Layout>} />
            <Route path="manage-services" element={<Layout>{<ManageServices />}</Layout>} />
            <Route path="profile-settings" element={<Layout>{<Profile />}</Layout>}></Route>
            <Route path="change-password" element={<Layout>{<ChangePassword />}</Layout>}></Route>
            <Route path="dispach-user" element={<Layout>{<AddDispatchUser />}</Layout>}></Route>
            <Route path="finance" element={<Layout>{<AdminFinance />}</Layout>}></Route>
            <Route path="quote" element={<Layout>{<Quote />}</Layout>}></Route>
            <Route path="notification" element={<Layout>{<ViewAllNotification />}</Layout>} />
            <Route path="payment-success/:order_id" element={<PaymentSuccess />} />
            <Route path="payment-error" element={<PaymentFailed />} />
          </Route>
        </Route>

        <Route element={<Authmiddleware allowed={UserTypes.DRIVER} />}>
          <Route path="/driver" element={<Outlet />}>
            <Route path="place-orders" element={<Layout>{<Users />}</Layout>} />
            <Route path="review" element={<Layout>{<Users />}</Layout>} />
            <Route path="available-orders" element={<Layout>{<DriverAvailableOrders />}</Layout>} />

          </Route>
        </Route>

        <Route path="/not-found" element={<Pages404 />}></Route>
        <Route path="*" element={<Pages404 />}></Route>
      </Routes>
    </React.Fragment>
  );
};

export default App;
